import type { UserModule } from '~/types'
import { browserTracingIntegration, init, replayIntegration } from '@sentry/vue'

const ignoreErrors = [
  /ResizeObserver/,
  // Wallets
  /.*TrustWeb3Provider*/g,
  /.*trustwallet*/g,
  /.*solana*/g,
  // Known errors
  /.*Too many requests*/g,
  /.*Loading chunk*/g,
  /.*Load failed*/g,
  /.*Cancel rendering route*/g,
  /.*currentTarget, detail, isTrusted, target*/g,
  /.*Network Error*/g,
  /.*Failed to fetch*/g,
  /.*User rejected request*/g,
  /.*The source https*/g,
  /.*Missing or invalid topic field*/g,
  /.*AbortError: The user aborted a request*/g,
  /.*INVALID_ARGUMENT*/g,
  /.*Invalid JSON RPC response*/g,
  /.*Blocked a frame with origin*/g,
  /.*User closed modal*/g,
  /.*Something went wrong!*/g,
  /.*WalletConnectionError: User rejected the request*/g,
  /.*timeout exceeded*/g,
  /.*No error message*/g,
  /.*Failed to execute 'insertBefore'*/g,
  /.*Insufficient balance*/g,
  /.*WebSocket connection failed*/g,
  /.*Unauthorized: origin not allowed*/g,
  /.*WalletNotSelectedError*/g,
  /.*WalletNotReadyError*/g,
]

export const install: UserModule = ({ app, router, isClient }) => {
  const dsn = import.meta.env.VITE_SENTRY_DSN

  if (dsn && isClient) {
    init({
      app,
      dsn,
      release: import.meta.env.VERSION,
      environment: import.meta.env.MODE,
      tracesSampleRate: 0.2,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1,
      integrations: [
        browserTracingIntegration({ router }),
        replayIntegration(),
      ],
      ignoreErrors,
      tracePropagationTargets: ['solanastaking.kiwi', 'localhost', /^\//],
    })
  }
}
